import React from "react";

const Flags = ({ className, variant = "", children, widthreprom = 0 }: any) => {

  const TYPES: any = {
    Vencida: " is-vencida",
    cancelada: " is-cancelada",
    Vigente: " is-vigente",
    pendiente: " is-pendiente",
    emitida: " is-emitida",
    rechazada: " is-rechazada",
    vencida: " is-vencida",
    vigente: " is-vigente",
    enFila: " is-enlinea",
    errEmitida: " is-rechazada",
    firmado: " is-firmado",
    errPago: " is-rechazada",
    ["Error de pago"]: " is-rechazada",
    porFirmar: " is-porFirmar",
    ["Por firmar"]: " is-porFirmar",
    revision: " is-revision",
    suscrita: " is-emitida",
    enProceso: " is-vigente",
    ingresado: " is-revision",
    ingresadoRp: " is-pendiente",
    cotizado: " is-emitida",
    mejorado: " is-mejorado",
    enviadoMeller: " is-enviadoMeller",
    ganado: " is-ganada",
    perdido: " is-perdido",
    recalculado: " is-recalculado",
    cartaEnviada: " is-cartaEnviada",
    datosActualizados: " is-porFirmar",
    enviadoEmision: " is-emitidas",
    errorCotizacion: " is-rechazada",
    aprobada: " is-emitida",
    ingresadoSRP: " ingresado-srp",
    anulado: " is-rechazada"
  };

  const modifier = widthreprom == 0 ?  TYPES[variant] || "-" : TYPES['ingresadoSRP'];

  return (
    <>
      {children && (
        <code
          className={"flag" + (className ? " " + className : "") + modifier}
        >
          {children}
        </code>
      )}
    </>
  );
};

export default Flags;
